<template>
  <div class="relative selection:bg-blue-700 selection:text-white font-sans">
    <transition name="fade">
      <div v-if="showMessage" class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
        <div class="bg-white p-8 rounded-2xl shadow-xl text-center max-w-md w-full" data-aos="zoom-in">
          <h2 class="text-2xl font-bold text-green-600 mb-3">
            Message envoyé avec succès !
          </h2>
          <p class="text-gray-600 mb-6">
            Merci pour votre message. Notre équipe vous répondra dans les plus brefs délais.
          </p>
          <button @click="showMessage = false"
            class="px-6 py-2 bg-blue-700 text-white rounded-md hover:bg-blue-800 transition">
            Fermer
          </button>
        </div>
      </div>
    </transition>

    <section class="relative w-full h-[60vh] lg:h-[40vh] overflow-hidden" data-aos="fade-down">
      <img :src="require('@/assets/images/image_contact.jpg')" alt="Contact Nova Lingua"
        class="absolute inset-0 w-full h-full object-cover" />
      <div class="absolute inset-0 bg-black/60 flex flex-col items-center justify-center text-center px-4">
        <h1 class="uppercase text-4xl lg:text-5xl font-bold text-white" data-aos="fade-up">
          Contactez-nous
        </h1>
        <div class="flex space-x-2 items-center justify-center mt-2" data-aos="fade-up" data-aos-delay="300">
          <router-link to="/" class="text-white hover:text-blue-400 transition">Accueil</router-link>
          <span class="text-white">•</span>
          <p class="text-blue-300 font-medium">Contact</p>
        </div>
      </div>
    </section>

    <section class="bg-gray-50 py-16 px-6 md:px-12 lg:px-24">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div data-aos="fade-right" class="space-y-6">
          <h2 class="text-2xl font-bold text-[#073183] mb-4">
            Envoyez-nous un message
          </h2>
          <form @submit.prevent="submitForm" class="space-y-5">
            <div class="flex flex-col sm:flex-row gap-4">
              <input type="text" placeholder="Votre nom complet" required
                class="border-2 border-gray-300 p-4 w-full focus:border-[#073183] outline-none duration-300 rounded-md" />
              <input type="email" placeholder="Entrez votre mail" required
                class="border-2 border-gray-300 p-4 w-full focus:border-[#073183] outline-none duration-300 rounded-md" />
            </div>

            <input type="text" placeholder="Sujet de votre message" required
              class="border-2 border-gray-300 p-4 w-full focus:border-[#073183] outline-none duration-300 rounded-md" />

            <textarea placeholder="Comment pouvons-nous vous aider ?" rows="6" required
              class="border-2 border-gray-300 p-4 w-full focus:border-[#073183] outline-none duration-300 rounded-md"></textarea>

            <button type="submit"
              class="uppercase text-white bg-[#073183] px-8 py-3 rounded-md font-semibold hover:bg-blue-800 transition shadow-lg">
              Envoyer le message
            </button>
          </form>
        </div>

        <div data-aos="fade-left" class="space-y-8">
          <div class="flex items-center space-x-3">
            <h2 class="text-2xl font-bold text-[#073183]">Nos coordonnées</h2>
            <div>
              <div class="w-24 h-[2px] bg-[#073183]"></div>
              <div class="w-32 h-[2px] bg-red-600 mt-1"></div>
            </div>
          </div>

          <p class="text-gray-600 leading-relaxed">
            Vous souhaitez en savoir plus sur nos formations ou nos procédures de voyage ? Contactez notre équipe sur l'un de nos sites, toujours disponible pour vous accompagner.
          </p>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-8 lg:gap-4">
            <div class="space-y-4">
              <h3 class="text-lg font-bold text-blue-700 flex items-center gap-2">
                <img src="@/assets/icons/map.png" class="w-5 h-5" alt="map" />
                Campus Bafoussam
              </h3>
             <div class="text-sm text-gray-700 space-y-2 pl-7">
  <p>📍 Ndiendam, 30m du marché de l’entrée, droite du collège Pointe</p>

  <p>
    📞 <strong>Secrétariat :</strong> 
    <a href="https://wa.me/237656531225" target="_blank" class="text-blue-600 hover:underline font-medium">
      +237 656 53 12 25
    </a>
  </p>

  <p>
    📞 <strong>Direction :</strong> 
    <a href="https://wa.me/237681834111" target="_blank" class="text-blue-600 hover:underline font-medium">
      +237 681 83 41 11
    </a>
  </p>
</div>
            </div>

            <div class="space-y-4">
              <h3 class="text-lg font-bold text-indigo-700 flex items-center gap-2">
                <img src="@/assets/icons/map.png" class="w-5 h-5" alt="map" />
                Campus Dschang
              </h3>
              <div class="text-sm text-gray-700 space-y-2 pl-7">
  <p>📍 En Face de l'entree de la chefferie Foto, dans l'immeuble abritant la boulangerie la paix et  la pharmacie de l'unite au 2eme etage</p>

    <p>
      📞 <strong>Contact :</strong> 
      <a 
        href="https://wa.me/237695632089" 
        target="_blank" 
        class="text-blue-600 hover:underline font-medium transition-colors"
      >
        +237 695 63 20 89
      </a>
    </p>
  </div>
            </div>
          </div>

          <div class="pt-6 border-t border-gray-200 space-y-4 text-gray-700">
            <div class="flex items-center space-x-3">
              <img src="@/assets/icons/mail.png" class="w-6 h-6" alt="mail" />
              <p>
                <span class="block font-medium">Emails officiels :</span>
                <a href="mailto:novalinguabafoussam@gmail.com" class="text-blue-600 hover:underline">novalinguabafoussam@gmail.com</a><br/>
                <a href="mailto:Novalingua.d@gmail.com" class="text-blue-600 hover:underline">Novalingua.d@gmail.com</a>
              </p>
            </div>

            <div class="flex items-center space-x-3">
              <img src="@/assets/icons/google.png" class="w-6 h-6" alt="google" />
              <p class="font-medium">NovaLingua Officiel</p>
            </div>
            
         <div class="flex items-center space-x-3">
  <span class="text-xl">🌍</span>
  <p>
    <span class="font-medium">Direction Générale (DE) :</span> 
    <a 
      href="https://wa.me/491754126763" 
      target="_blank" 
      class="text-blue-600 hover:underline font-bold transition-colors"
    >
      +49 175 412 67 63
    </a>
  </p>
</div>
          </div>
        </div>
      </div>
    </section>

    <section class="w-full h-[50vh]" data-aos="fade-up">
      <iframe class="w-full h-full"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3972.285810264101!2d10.42!3d5.47!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNcKwMjgnMTIuMCJOIDEwwrAyNScxMi4wIkU!5e0!3m2!1sfr!2scm!4v1630000000000!5m2!1sfr!2scm"
        style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
     <section class="w-full h-[50vh] mt-2" data-aos="fade-up">
      <iframe  class="w-full h-full" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d254190.02458426033!2d9.763026994531241!3d5.459525600000008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x105fb13424eeed13%3A0x7eb0844e244ce9e7!2sCenter%20Linguistic%20Novalingua!5e0!3m2!1sen!2scm!4v1768414919122!5m2!1sen!2scm" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

const showMessage = ref(false);

onMounted(() => {
  AOS.init({
    duration: 800,
    easing: "ease-in-out",
    once: false,
    mirror: true,
    offset: 120,
  });
});

const submitForm = () => {
  showMessage.value = true;
  // Logique d'envoi réelle ici (ex: API call)
  setTimeout(() => (showMessage.value = false), 4000);
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>